// US locale: fr
export default {
  "login.title": "MedConcil",
  "login.subtitle": "Aide à la décision clinique",
  "login.welcome": "Bienvenue",
  "login.signInMessage": "Sign in to access your MedConcil workspace",
  "login.continueWithGoogle": "Continue with Google",
  "login.terms": "By signing in, you agree to our Terms of Service and Privacy Policy",
  "login.feature1.title": "Multi-Model Consensus",
  "login.feature1.desc": "Query GPT and Op simultaneously",
  "login.feature2.title": "Enterprise PII Protection",
  "login.feature2.desc": "Automatic redaction of sensitive data before LLM processing",
  "login.feature3.title": "Team Collaboration",
  "login.feature3.desc": "Full audit logging and cost governance for your organization",
  "login.signInDesc": "Connectez-vous pour accéder au consilium clinique",
  "login.signInGoogle": "Se connecter avec Google",
  "login.signingIn": "Connexion...",
  "login.signInEmail": "Se connecter par e-mail",
  "login.password": "Mot de passe",
  "login.register": "Créer un compte",
  "login.noAccount": "Pas de compte ?",
  "login.createAccount": "En créer un",
  "login.hasAccount": "Déjà un compte ?",
  "login.signIn": "Se connecter",
  "login.or": "ou",
  "login.checkEmail": "Check your email for the confirmation link",
  "login.error": "Sign in failed",
  "login.oauthNotConfigured": "This sign-in method is not available in this deployment.",
  "login.forgotPassword": "Mot de passe oublié ?",
  "login.rememberMe": "Se souvenir de moi",
  "login.emailVerified": "Email verified. Please sign in.",
  "login.resetSent": "Password reset link sent to your email",
  "login.enterEmailFirst": "Enter your email first",
  "login.gdpr": "GDPR Compliant",
  "login.pii": "PII Redacted",
  "login.footer": "Clinical Decision Support - Not a Replacement for Physician Judgment",
  "legal.termsNoticeSignin": "By signing in, you agree to our",
  "legal.termsNoticeSignup": "By creating an account, you agree to our",
  "legal.privacyPolicy": "Privacy Policy",
  "legal.termsOfUse": "Terms of Use",
  "legal.cookiePolicy": "Cookie Policy",
  "legal.and": "and",
  "legal.redirecting": "Redirecting to the legal page…",
  "nav.voice": "Voice",
  "nav.query": "Query",
  "nav.history": "History",
  "nav.admin": "Admin",
  "nav.adminSection": "Admin",
  "nav.clinicalSupport": "Clinical Decision Support",
  "nav.account": "Account",
  "nav.settings": "Settings",
  "nav.signOut": "Sign out",
  "nav.activeCouncil": "Active Council",
  "nav.plan": "plan",
  "voice.pageTitle": "Voice Recording",
  "voice.readyTitle": "Record an appointment",
  "voice.readyDesc": "Press to start recording a conversation with the patient",
  "voice.consent": "Make sure the patient has given consent to recording",
  "voice.recordingLabel": "Recording in progress",
  "voice.transcribing": "Recognizing speech...",
  "voice.reviewLabel": "Conversation transcript â edit if needed",
  "voice.send": "Send to Consilium",
  "voice.reRecord": "Record again",
  "voice.noKey": "Groq API key not set",
  "voice.noKeyTitle": "Groq API key not set",
  "voice.noKeyDesc": "Add the key in the Admin section for speech recognition to work",
  "voice.goToAdmin": "Go to Admin",
  "voice.permDenied": "Microphone access denied. Check browser permissions.",
  "voice.noSupport": "Browser does not support audio recording",
  "admin.groqKeyLabel": "Groq API Key (for speech recognition)",
  "admin.groqKeyDesc": "Key for speech recognition via Groq Whisper. Stored locally in browser.",
  "admin.groqPersonalLabel": "Personal key (this browser only)",
  "admin.groqServerLabel": "Default key (for all users)",
  "admin.groqServerActive": "Active for all users",
  "admin.groqServerKeySet": "Server key is configured",
  "admin.groqServerKeyNotSet": "No server key set",
  "admin.groqServerSaved": "Server key saved",
  "admin.groqServerError": "Failed to save server key",
  "admin.groqKeySaved": "Groq API key saved",
  "admin.groqKeyCleared": "Groq API key cleared",
  "admin.saved": "Saved",
  "admin.save": "Save",
  "query.voiceCardTitle": "Record an appointment",
  "query.voiceCardDesc": "Record a conversation with the patient and send it to the Consilium",
  "query.chairmanStreaming": "Chairman is composing the response...",
  "query.title": "Ask the Consilium",
  "query.placeholder": "Ask anything... The consilium will deliberate and provide a consensus answer.",
  "query.piiNotice": "PII is automatically redacted",
  "query.submit": "Demander au conseil",
  "query.textSize": "Taille du texte",
  "query.textSizeDecrease": "Réduire le texte",
  "query.textSizeIncrease": "Agrandir le texte",
  "query.loading": "Consilium is deliberating...",
  "query.consiliumWorking": "Consilium is deliberating...",
  "query.remaining": "remaining",
  "query.almostDone": "Almost done...",
  "query.attachmentWaitNote": "Attached documents take longer — each advisor reads the full file. Please stay on this page.",
  "query.stagePii": "PII screening",
  "query.stageModels": "Models analyzing",
  "query.stageChairman": "Chairman synthesizing",
  "query.stageSaving": "Finalizing",
  "query.success": "Consilium has responded!",
  "query.stage1": "Individual Responses",
  "query.stage3": "Consilium Synthesis",
  "query.chairmanNote": "The Consilium reviewed all responses and compiled this final answer",
  "query.patientMessage": "Patient Message",
  "query.readyToSend": "Ready to review",
  "query.patientMessageNote": "Review and send to the patient. Written in plain language.",
  "query.physicianReview": "Physician Review Summary",
  "query.internalOnly": "Internal",
  "query.tokens": "Tokens",
  "query.yourCost": "Your Cost",
  "query.piiRedacted": "PII entities redacted",
  "query.models": "models",
  "query.emptyTitle": "Ready to consult the Consilium",
  "query.emptyDesc": "Your query will be sent to multiple AI models. They'll analyze and the consilium will synthesize the best answer.",
  "query.addImage": "Photo",
  "query.addFile": "File",
  "query.fileTooLarge": "File too large (max 25MB)",
  "query.tooManyFiles": "Too many files (max {max}).",
  "query.attachmentsTooLarge": "Total attachments too large (max 50MB).",
  "query.unsupportedFile": "Unsupported file type",
  "query.imageTooLarge": "Image too large (max 10MB)",
  "query.timeout": "Query timed out. Please try again.",
  "query.followupTitle": "Follow-up questions to the council",
  "query.followupPlaceholder": "Ask a follow-up question...",
  "query.followupError": "Error sending question",
  "query.followupLimitExceeded": "Follow-up limit reached for this case.",
  "query.followupLimitReached": "You've used all follow-up questions for this case. Start a new case to continue.",
  "query.followupAttachmentsExhausted": "Follow-up attachment limit reached for this case.",
  "query.followupStartNewCase": "Start a new case",
  "query.copied": "Copied",
  "query.copy": "Copy",
  "query.downloadPdf": "Download PDF",
  "query.pdfDownloaded": "PDF downloaded",
  "query.pdfError": "Error downloading PDF",
  "query.pdfNoQuery": "No data to download â run a query first",
  "history.title": "Query History",
  "history.queries": "queries",
  "history.exportCsv": "Export CSV",
  "history.searchPlaceholder": "Search queries...",
  "history.startDate": "Start date",
  "history.endDate": "End date",
  "history.start": "Start",
  "history.end": "End",
  "history.clear": "Clear",
  "history.noQueries": "No queries yet",
  "history.timestamp": "Timestamp",
  "history.queryCol": "Query",
  "history.modelsCol": "Models",
  "history.costCol": "Your Cost",
  "history.piiCol": "PII",
  "history.view": "View",
  "history.queryDetails": "Détails du cas",
  "history.caseSummary": "Résumé du cas",
  "history.synthesis": "Résumé",
  "history.exported": "History exported!",
  "admin.title": "Admin Panel",
  "admin.dashboard": "Dashboard",
  "admin.auditLog": "Audit Log",
  "admin.team": "Team",
  "admin.settings": "Settings",
  "admin.accessDenied": "Access Denied",
  "admin.noPermission": "You don't have permission to access this page.",
  "dashboard.queriesThisMonth": "Queries this month",
  "dashboard.totalSpend": "Total spend",
  "dashboard.activeUsers": "Active users",
  "dashboard.avgCostPerQuery": "Avg cost/query",
  "dashboard.queriesPerDay": "Queries per Day",
  "dashboard.spendByModel": "Spend by Model",
  "dashboard.topUsers": "Top Users",
  "dashboard.user": "User",
  "dashboard.queries": "Queries",
  "dashboard.spend": "Spend",
  "dashboard.noData": "No data yet",
  "team.title": "Team Members",
  "team.members": "members",
  "team.inviteMembers": "Invite Members",
  "team.inviteTitle": "Invite Team Members",
  "team.inviteDesc": "Add new members to your organization",
  "team.emailAddresses": "Email Addresses",
  "team.emailPlaceholder": "john@example.com, jane@example.com",
  "team.role": "Role",
  "team.member": "Member",
  "team.adminRole": "Admin",
  "team.auditor": "Auditor",
  "team.owner": "Owner",
  "team.cancel": "Cancel",
  "team.sendInvites": "Send Invites",
  "team.joined": "Joined",
  "team.actions": "Actions",
  "team.pendingInvites": "Pending Invites",
  "settings.councilConfig": "Configuration du Consilium",
  "settings.councilConfigDesc": "Configurez les spécialistes IA qui participent au consilium",
  "settings.councilMembers": "Membres du Consilium",
  "settings.chairmanModel": "Modèle du Président",
  "settings.personasTitle": "Spécialistes",
  "settings.personasDesc": "Activez des spécialistes, choisissez leur modèle sous-jacent et définissez le conseil par défaut",
  "settings.personaSpecialty": "Spécialité",
  "settings.personaBackingModel": "Modèle sous-jacent",
  "settings.personaEnabled": "Activé",
  "settings.defaultCouncilMember": "Dans le conseil par défaut",
  "settings.chairmanPersona": "Président",
  "settings.atLeastOneCouncilMember": "Sélectionnez au moins un spécialiste activé pour le conseil par défaut",
  "settings.chairmanMustBeEnabled": "Le spécialiste président doit rester activé",
  "settings.chairmanRequired": "Un spécialiste président est requis",
  "settings.personaModelRequired": "Chaque spécialiste sélectionné doit avoir un modèle sous-jacent",
  "settings.councilNotConfigured": "Conseil non configuré",
  "settings.piiRedaction": "PII Redaction",
  "settings.piiRedactionDesc": "Automatically redact sensitive data",
  "settings.saveModelSettings": "Save Model Settings",
  "settings.budgetSettings": "Budget Settings",
  "settings.budgetSettingsDesc": "Control your organization's spending",
  "settings.monthlyLimit": "Monthly Limit (USD)",
  "settings.unlimitedPlaceholder": "Leave empty for unlimited",
  "settings.alertThreshold": "Alert Threshold",
  "settings.currentSpend": "Current spend",
  "settings.saveBudgetSettings": "Save Budget Settings",
  "settings.dangerZone": "Danger Zone",
  "settings.resetMonthlySpend": "Reset Monthly Spend",
  "settings.resetDesc": "Set current month spend to $0.00",
  "settings.reset": "Reset",
  "settings.resetConfirmTitle": "Reset Monthly Spend?",
  "settings.resetConfirmDesc": "This will set the current month spend counter to $0.00. This action cannot be undone.",
  "settings.saving": "Saving...",
  "audit.filterByEmail": "Filter by email...",
  "audit.startDate": "Start",
  "audit.endDate": "End",
  "audit.export": "Export",
  "audit.timestamp": "Timestamp",
  "audit.user": "User",
  "audit.query": "Query",
  "audit.models": "Models",
  "audit.cost": "Cost",
  "audit.noLogs": "No audit logs found",
  "audit.exported": "Audit logs exported!",
  "audit.loadError": "Failed to load audit logs",
  "toast.dashboardError": "Failed to load dashboard",
  "toast.teamError": "Failed to load team",
  "toast.invitesSent": "Invitations sent!",
  "toast.inviteError": "Failed to send invites",
  "toast.roleUpdated": "Role updated",
  "toast.roleError": "Failed to update role",
  "toast.userRemoved": "User removed",
  "toast.userRemoveError": "Failed to remove user",
  "toast.modelsSaved": "Model settings saved!",
  "toast.modelsError": "Failed to save settings",
  "toast.budgetSaved": "Budget settings saved!",
  "toast.budgetError": "Failed to save settings",
  "toast.budgetReset": "Budget spend reset!",
  "toast.budgetResetError": "Failed to reset budget",
  "toast.settingsError": "Failed to load settings",
  "account.title": "Account",
  "account.profile": "Profile",
  "account.organization": "Organization",
  "account.billing": "Billing",
  "account.billingDesc": "Manage your subscription and billing",
  "account.apiKey": "API Key",
  "account.apiKeyDesc": "Use this key to access MedConcil programmatically",
  "account.regenerate": "Regenerate API Key",
  "account.regenerateConfirmTitle": "Regenerate API Key?",
  "account.regenerateConfirmDesc": "Your current API key will be invalidated immediately. Any applications using the old key will stop working.",
  "account.regenerating": "Regenerating...",
  "account.exampleUsage": "Example usage:",
  "account.upgrade": "Upgrade",
  "account.billingComingSoon": "Billing integration coming soon. Contact support to upgrade.",
  "onboarding.createOrg": "Create your organization",
  "onboarding.setupWorkspace": "Set up your workspace",
  "onboarding.configureCouncil": "Configure Consilium",
  "onboarding.selectModels": "Select AI models",
  "onboarding.setBudget": "Set spending limits",
  "onboarding.controlSpending": "Control spending",
  "onboarding.inviteTeam": "Invite your team",
  "onboarding.addCollaborators": "Add collaborators",
  "onboarding.createOrgTitle": "Create your organization",
  "onboarding.createOrgDesc": "This will be your team's workspace",
  "onboarding.orgName": "Organization Name",
  "onboarding.orgNamePlaceholder": "My Clinic",
  "onboarding.workspaceUrl": "Workspace URL",
  "onboarding.createOrgBtn": "Create Organization",
  "onboarding.creating": "Creating...",
  "onboarding.configureCouncilTitle": "Configure your Consilium",
  "onboarding.configureCouncilDesc": "Select which AI models will participate in consensus",
  "onboarding.chairmanNote": "This model synthesizes the final consensus answer",
  "onboarding.back": "Back",
  "onboarding.continue": "Continue",
  "onboarding.setBudgetTitle": "Set spending limits",
  "onboarding.setBudgetDesc": "Control your monthly AI spend",
  "onboarding.budgetNote": "Set a monthly spending cap. Leave empty for no limit.",
  "onboarding.alertNote": "Get notified when spending reaches this percentage of your budget",
  "onboarding.skip": "Skip",
  "onboarding.inviteTeamTitle": "Invite your team",
  "onboarding.inviteTeamDesc": "Add teammates to collaborate",
  "onboarding.separateEmails": "Separate multiple emails with commas",
  "onboarding.defaultRole": "Default Role",
  "onboarding.skipFinish": "Skip & Finish",
  "onboarding.completeSetup": "Complete Setup",
  "onboarding.settingUp": "Setting up...",
  "common.loading": "Loading...",
  "common.error": "Error",
  "common.success": "Success",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.close": "Close",
  "common.back": "Back",
  "common.confirm": "Confirm",
  "common.authError": "Session expired. Please log in again.",
  "common.language": "Langue",
  "common.english": "English",
  "common.spanish": "Español",
  "common.arabic": "العربية",
  "common.french": "Français",
  "common.russian": "Русский",
  "login.displayNameOptional": "Nom d'affichage (facultatif)",
  "login.signUpTitle": "Inscription",
  "login.signUpWithEmail": "S'inscrire par e-mail",
  "login.signUpDesc": "Sign up to access the clinical council",
  "nav.patients": "Patients",
  "nav.platform": "Plateforme",
  "nav.newQuery": "Nouvelle requête",
  "query.newQuery": "Nouvelle requête",
  "query.filesOnly": "Analysez les documents et images joints.",
  "query.confirmNewQuery": "Query is still processing. Start a new one?",
  "query.confirmNewQueryForce": "Query is still processing. Are you sure you want to start a new one?",
  "reset.invalidLink": "Invalid Link",
  "reset.tokenMissing": "Reset token is missing.",
  "reset.backToLogin": "Back to Login",
  "reset.passwordUpdated": "Password Updated",
  "reset.canSignIn": "You can now sign in with your new password.",
  "reset.signIn": "Sign In",
  "reset.newPassword": "New Password",
  "reset.enterNewPassword": "Enter a new password for your account",
  "reset.confirmPassword": "Confirm password",
  "reset.savePassword": "Save Password",
  "reset.passwordMin": "Password must be at least 6 characters",
  "reset.passwordMismatch": "Passwords do not match",
  "reset.success": "Password updated successfully",
  "reset.linkInvalid": "Link is invalid or expired",
  "reset.failed": "Password reset failed",
  "patients.title": "Dossiers patients",
  "patients.newPatient": "Nouveau patient",
  "patients.searchPlaceholder": "Search by name...",
  "patients.noPatients": "No patients",
  "patients.name": "Name",
  "patients.birthDate": "Date of birth",
  "patients.gender": "Gender",
  "patients.genderMale": "M",
  "patients.genderFemale": "F",
  "patients.actions": "Actions",
  "patients.open": "Open",
  "patients.loadError": "Échec du chargement du dossier",
  "patients.nameRequired": "Le nom est requis",
  "patients.saved": "Patient saved",
  "patients.saveError": "Failed to save",
  "patients.deleted": "Patient deleted",
  "patients.deleteError": "Failed to delete",
  "patients.back": "Back",
  "patients.edit": "Edit",
  "patients.delete": "Delete",
  "patients.newPatientTitle": "New Patient",
  "patients.editPatientTitle": "Edit Patient",
  "patients.save": "Save",
  "patients.saving": "Saving...",
  "patients.personalInfo": "Personal information",
  "patients.fullName": "Full name",
  "patients.phone": "Phone",
  "patients.email": "Email",
  "patients.medicalProfile": "Medical profile",
  "patients.bloodType": "Blood type",
  "patients.allergies": "Allergies",
  "patients.diagnoses": "Chronic diagnoses",
  "patients.medications": "Current medications",
  "patients.surgeries": "Surgical history",
  "patients.familyHistory": "Family history",
  "patients.notes": "Notes",
  "patients.documents": "Documents",
  "patients.sessions": "Consilium sessions",
  "patients.upload": "Upload",
  "patients.askConsilium": "Ask Consilium",
  "patients.deleteConfirmTitle": "Delete patient?",
  "patients.deleteConfirmDesc": "This action cannot be undone.",
  "patients.cancel": "Cancel",
  "patients.notFound": "Patient not found",
  "patients.genderMaleFull": "Male",
  "patients.genderFemaleFull": "Female",
  "patients.consilium": "Consilium",
  "patients.profile": "Profile",
  "patients.contact": "Contact",
  "patients.snils": "SNILS",
  "patients.snilsPlaceholder": "123-456-789 00",
  "patients.mrn": "MRN",
  "patients.mrnPlaceholder": "12345678",
  "patients.phonePlaceholderUs": "+1 (555) 555-5555",
  "patients.phonePlaceholderCis": "+7...",
  "patients.created": "Created",
  "patients.diagnosis": "Diagnosis",
  "patients.status": "Status",
  "patients.medication": "Medication",
  "patients.dose": "Dose",
  "patients.frequency": "Frequency",
  "patients.patientDocuments": "Patient Documents",
  "patients.titleCol": "Title",
  "patients.category": "Category",
  "patients.date": "Date",
  "patients.size": "Size",
  "patients.noDocuments": "No documents",
  "patients.mode": "Mode",
  "patients.docUploaded": "Document uploaded",
  "patients.uploadError": "Upload error",
  "patients.docDeleted": "Document deleted",
  "patients.add": "Add",
  "patients.searchNamePhone": "Search by name or phone...",
  "patients.search": "Search",
  "patients.birthDateShort": "Birth Date",
  "patients.genderShort": "Sex",
  "patients.noPatientsYet": "No patients yet",
  "patients.noSessionsYet": "No sessions yet",
  "patients.deleteCardTitle": "Delete patient card?",
  "patients.cardUpdated": "Card updated",
  "patients.patientCreated": "Patient created",
  "patients.editCard": "Edit Card",
  "patients.basicInfo": "Basic Info",
  "patients.genderOther": "Other",
  "patients.noAllergies": "No allergies",
  "patients.substance": "Substance",
  "patients.severity": "Severity",
  "patients.severityMild": "Mild",
  "patients.severityModerate": "Moderate",
  "patients.severitySevere": "Severe",
  "patients.reaction": "Reaction",
  "patients.noDiagnoses": "No diagnoses",
  "patients.nameLabel": "Name",
  "patients.icd10": "ICD-10",
  "patients.noMedications": "No medications",
  "patients.noSurgeries": "No surgeries",
  "patients.hospital": "Hospital",
  "patients.familyHistoryHint": "Family history (comma-separated)",
  "patients.additionalNotes": "Additional notes",
  "patients.statusActive": "Active",
  "patients.statusRemission": "Remission",
  "patients.statusResolved": "Resolved",
  "patients.surgery": "Surgery",
  "patients.familyNotes": "Family History & Notes",
  "patients.familyExample": "Diabetes (mother)",
  "patients.additionalNotesPlaceholder": "Additional notes...",
  "onboarding.stepOrg": "Create Organization",
  "onboarding.stepCouncil": "Configure Council",
  "onboarding.stepBudget": "Set Budget",
  "onboarding.stepTeam": "Invite Team",
  "onboarding.slugPlaceholder": "my-clinic",
  "onboarding.orgCreated": "Organization created!",
  "onboarding.fillFields": "Please fill in all fields",
  "onboarding.configCouncil": "Configure your Council",
  "onboarding.configCouncilDesc": "Select AI models for consensus",
  "onboarding.councilMembers": "Council Members",
  "onboarding.chairmanModel": "Chairman Model",
  "onboarding.chairmanModelDesc": "This model synthesizes the final consensus answer",
  "onboarding.monthlyBudget": "Monthly Budget",
  "onboarding.budgetPlaceholder": "Leave empty for unlimited",
  "onboarding.budgetHint": "Set a monthly spending cap. Leave empty for no limit.",
  "onboarding.alertThreshold": "Alert Threshold",
  "onboarding.alertHint": "Get notified when spending reaches this percentage",
  "onboarding.emailAddresses": "Email Addresses",
  "onboarding.emailsHint": "Separate multiple emails with commas",
  "onboarding.roleMember": "Member",
  "onboarding.roleAdmin": "Admin",
  "onboarding.roleAuditor": "Auditor",
  "onboarding.setupComplete": "Setup complete!",
  "onboarding.startBtn": "Get Started",

  // Patient picker / confirm modals
  "patient.phonePlaceholderUs": "+1 (555) 555-5555",
  "patient.phonePlaceholderCis": "+7 916 123-45-67",
  "patient.errPhoneFormatUs": "Format : +1XXXXXXXXXX",
  "patient.errPhoneFormatCis": "Format : +7XXXXXXXXXX",
  "query.councilEmptyUsesDefault": "Les médecins seront choisis pour votre cas.",
  "query.councilAutomatic": "Les médecins seront choisis pour votre cas.",
  "query.councilGroupGeneralist": "Médecine générale",
  "query.councilGroupMedical": "Spécialités médicales",
  "query.councilGroupSurgical": "Spécialités chirurgicales",
  "query.councilGroupDiagnostic": "Diagnostic",
  "query.councilSearchPlaceholder": "Rechercher par nom ou spécialité",
  "query.councilClearAutomatic": "Effacer (automatique)",
  "query.councilSelectedForCase": "Choisis pour votre cas",
  "query.councilExpandSpecialists": "Choisir des spécialistes",
  "query.councilCollapseSpecialists": "Masquer les spécialistes",
  "billing.getMoreCases": "Obtenir plus de cas",
  "billing.viewPlans": "Voir les forfaits",
  "query.b2cSummary": "Résumé",
  "query.b2cNextSteps": "Vos prochaines étapes",
  "query.perspectiveLabel": "Conseiller IA · {specialty}",
  "query.perspectiveFallback": "Conseiller IA",
  "query.perspectiveMarker": "AI",
  "query.perspectiveRow": "Perspectives · AI",
  "query.disclaimerRequired": "Accept the current clinical notice before submitting a case.",
  "healthProfile.units.label": "Unités",
  "healthProfile.units.metric": "Métrique",
  "healthProfile.units.imperial": "Impérial",
  "healthProfile.heightFt": "Taille (pi)",
  "healthProfile.heightIn": "Taille (po)",
  "healthProfile.weightLb": "Poids (lb)",
  "nav.myCases": "Historique médical",
  "history.title": "Historique médical",
  "history.addRecord": "Ajouter un dossier",
  "history.summary": "Résumé",
  "history.timeline": "Chronologie",
  "history.uploadDocument": "Téléverser un document",
  "history.filesSelected": "{count} fichiers sélectionnés",
  "history.tooManyFiles": "Vous pouvez joindre jusqu'à {max} fichiers à un dossier.",
  "history.addEntry": "Ajouter une entrée",
  "history.category": "Catégorie",
  "history.eventDate": "Date des soins",
  "history.datePrecision": "Précision de la date",
  "history.precision.day": "Jour",
  "history.precision.month": "Mois",
  "history.precision.year": "Année",
  "history.dateUnknown": "Date inconnue",
  "history.titleField": "Titre",
  "history.facility": "Établissement ou clinicien",
  "history.notes": "Notes",
  "history.details": "Détails",
  "history.save": "Enregistrer",
  "history.cancel": "Annuler",
  "history.delete": "Supprimer",
  "history.deleteConfirm": "Supprimer ce dossier ? Cette action est définitive.",
  "history.deleteCaseDocuments.one": "Supprimer aussi le document enregistré depuis ce cas",
  "history.deleteCaseDocuments.many": "Supprimer aussi {n} documents enregistrés depuis ce cas",
  "history.attachedFiles.one": "{n} fichier joint",
  "history.attachedFiles.many": "{n} fichiers joints",
  "history.dateFromCase": "Date reprise du cas. Modifiez-la si le fichier est plus ancien.",
  "history.fromCase": "Du cas : {title}",
  "history.fromCaseDated": "D'un cas du {date}",
  "history.fromCaseUntitled": "D'un cas",
  "history.fromCasePending": "D'un cas en cours",
  "history.fromCaseDeleted": "D'un cas supprimé",
  "history.filePages": "{n} pages",
  "history.edit": "Modifier",
  "history.download": "Télécharger",
  "history.previewUnavailable": "Aperçu indisponible",
  "history.noRecords": "Aucun dossier pour le moment",
  "history.noOneOff": "Aucun cas ponctuel",
  "history.aiSecondOpinion": "Second avis IA — ce n'est pas un dossier médical",
  "history.recordCount": "{count} dossiers",
  "history.storageUsage": "{used} Mo utilisés sur {limit} Mo",
  "history.conditions": "Antécédents",
  "history.medications": "Médicaments",
  "history.allergies": "Allergies",
  "history.noneReported": "Aucun signalé",
  "history.notProvided": "Pas encore ajouté",
  "history.review": "Vérifier",
  "history.latest": "Le plus récent",
  "history.consentTitle": "Conserver les dossiers de santé",
  "history.consentAccept": "J'accepte",
  "history.consentRequired": "Acceptez le consentement de stockage avant d'ajouter un dossier.",
  "history.duplicateWarning": "Un fichier identique existe déjà. Les deux copies sont conservées.",
  "history.storageFull": "Le stockage de l'historique est plein. Retirez un gros fichier et réessayez.",
  "history.caseFilesNotSavedTitle": "Les fichiers n'ont pas été enregistrés",
  "history.caseFilesNotSaved": "Ces fichiers n'ont pas été enregistrés dans l'historique médical. Ajoutez-les plus tard depuis Historique médical.",
  "history.caseFilesNotSavedOk": "OK",
  "history.shareSessionExpired": "Votre session de consultation est terminée. Saisissez à nouveau le code d'accès.",
  "history.saved": "Dossier enregistré",
  "history.saveError": "Impossible d'enregistrer le dossier",
  "history.loadError": "Impossible de charger l'historique médical",
  "history.deleted": "Dossier supprimé",
  "history.saveFilesToHistory": "Enregistrer ces fichiers dans l'historique médical de {name}",
  "history.oneOffCases": "Cas ponctuels",
  "history.tierA": "Âge et sexe à la naissance",
  "history.fileUnavailable": "Fichier indisponible",
  "history.updated": "Mis à jour {date}",
  "history.source.user_upload": "Téléversé par vous",
  "history.source.user_entered": "Saisi par vous",
  "history.source.case_attachment": "Enregistré depuis un cas",
  "history.source.medconcil_case": "Cas MedConcil",
  "history.category.visit_note": "Note de visite",
  "history.category.discharge_summary": "Compte rendu de sortie",
  "history.category.lab_result": "Résultat de laboratoire",
  "history.category.imaging_report": "Compte rendu d'imagerie",
  "history.category.prescription": "Ordonnance",
  "history.category.procedure": "Procédure",
  "history.category.immunization": "Vaccination",
  "history.category.referral": "Orientation",
  "history.category.other": "Autre",
  "history.category.ai_second_opinion": "Second avis IA",
  "history.export": "Exporter",
  "history.exportTitle": "Exporter l’historique médical",
  "history.exportDescription": "Un résumé clinique pour un médecin. MedConcil ne vérifie pas ces dossiers.",
  "history.exportFormat": "Format",
  "history.format.pdf": "Résumé PDF",
  "history.format.fhir": "Résumé international du patient FHIR (JSON)",
  "history.format.zip": "ZIP avec PDF, FHIR et documents",
  "history.includeAiOpinions": "Inclure les seconds avis IA",
  "history.exportAiHint": "Les seconds avis IA sont exclus tant que cette case n’est pas cochée.",
  "history.exportWholeHistory": "Historique complet",
  "history.exportChooseRecords": "Choisir des dossiers",
  "history.pickerTruncated": "Affichage des {n} dossiers les plus récents. Les dossiers plus anciens de cette période sont inclus.",
  "history.exportIdentityTitle": "Nom légal et date de naissance",
  "history.exportIdentityHelp": "Les cliniques en ont besoin sur le résumé. Enregistrez-les pour la prochaine fois, ou utilisez-les une seule fois. Si le nom est vide, le document indique « Name not provided ».",
  "history.exportLegalName": "Nom légal",
  "history.exportDateOfBirth": "Date de naissance",
  "history.exportSaveIdentity": "Enregistrer pour les prochains exports",
  "history.exportUseSaved": "Utiliser le nom et la date de naissance enregistrés",
  "history.exportChangeIdentity": "Saisir un autre nom ou une autre date de naissance",
  "history.exportDownload": "Télécharger",
  "history.exportWorking": "Préparation de l’export…",
  "history.exportDone": "Export téléchargé",
  "history.exportError": "Impossible d’exporter l’historique médical",
  "history.exportTooLarge": "Cet export est trop volumineux. Désactivez les documents ou sélectionnez moins de dossiers et réessayez.",
  "history.shareDoctorNote": "Note pour le médecin",
  "history.exportIdentityInvalid": "Indiquez une vraie date de naissance, ou laissez le champ vide.",
  "history.share": "Partager",
  "history.shareTitle": "Partager avec un médecin",
  "history.shareDescription": "Un lien à durée limitée. Vous pouvez l'arrêter. Les copies déjà téléchargées restent chez le destinataire.",
  "history.shareExpires": "Le lien expire",
  "history.shareExpires.1h": "1 heure",
  "history.shareExpires.24h": "24 heures",
  "history.shareExpires.7d": "7 jours",
  "history.shareExpires.30d": "30 jours",
  "history.shareRequireCode": "Exiger un code à 6 chiffres",
  "history.shareNotify": "M'écrire quand le lien est ouvert pour la première fois",
  "history.shareConsentAccept": "J'accepte d'envoyer ces dossiers",
  "history.shareCreate": "Créer le lien",
  "history.shareWorking": "Création du lien…",
  "history.shareCodeOnce": "Copiez le lien et le code maintenant. Ils ne pourront plus être affichés.",
  "history.shareUrl": "Lien",
  "history.shareCode": "Code d'accès",
  "history.shareCopy": "Copier le lien",
  "history.shareCopyCode": "Copier le code",
  "history.shareCodeCopied": "Code copié",
  "history.shareCopied": "Lien copié",
  "history.shareDone": "Terminé",
  "history.shareError": "Impossible de mettre à jour le partage",
  "history.shareConsentRequired": "Acceptez le consentement de partage avant de créer un lien.",
  "history.shareLimit": "Cette personne a déjà le nombre maximal de liens actifs.",
  "history.shareWholeHistory": "Tout l'historique",
  "history.shareChooseRecords": "Choisir des dossiers",
  "history.shareIncludeSummary": "Inclure le résumé",
  "history.sharePersonFallback": "cette personne",
  "history.sharesTitle": "Liens partagés",
  "history.noActiveShares": "Aucun lien actif",
  "history.shareStop": "Arrêter le partage",
  "history.shareStopped": "Lien arrêté",
  "history.shareOpens": "Ouvert {count} fois",
  "history.shareExpiresAt": "Expire {date}",
  "history.shareCreatedAt": "Créé {date}",
  "history.shareScopeSummary": "Résumé",
  "history.shareScopeRecords": "{count} dossiers",
  "history.shareScopeAi": "Inclut les avis d'IA",
  "history.downloadPacket": "Télécharger",
  "history.shareWithDoctor": "Partager avec un médecin",
  "history.packetTitle": "Préparer pour un médecin",
  "history.packetDescription": "Choisissez ce que ce médecin doit voir, puis téléchargez un fichier ou créez un lien.",
  "history.packetStepInclude": "Quoi inclure",
  "history.packetStepSend": "Comment l'envoyer",
  "history.scopeProfile": "Résumé du profil (allergies, médicaments, affections, mode de vie)",
  "history.scopeIdentity": "Nom légal et date de naissance",
  "history.scopeDocuments": "Joindre les documents originaux",
  "history.scopeNote": "Note pour le médecin",
  "history.scopeNotePlaceholder": "Facultatif. 1 000 caractères maximum.",
  "history.scopePeriodWhole": "Période : historique complet",
  "history.scopePreview": "{records} dossiers · {documents} documents ({size}) · {consultations} consultations",
  "history.scopePreviewLoading": "Décompte des dossiers…",
  "history.packetSaveIdentity": "Enregistré pour les prochains dossiers",
  "history.packetSaveRequired": "Un lien qui comprend un nom ou une date de naissance les enregistre pour les prochains dossiers.",
  "history.packetIdentityOmitted": "Ce lien n'inclura pas le nom ni la date de naissance.",
  "history.chooseOneItem": "Choisissez au moins un élément.",
  "history.profileAsOf": "Profil à jour au {date}",
  "history.pregnancy": "Grossesse",
  "history.activeProblems": "Problèmes actifs",
  "history.vitals": "Constantes et mode de vie",
  "history.height": "Taille",
  "history.weight": "Poids",
  "history.bmi": "IMC",
  "history.smoking": "Tabac",
  "history.alcohol": "Alcool",
  "history.activity": "Activité",
  "history.sleep": "Sommeil",
  "history.surgeries": "Actes et chirurgies",
  "history.scopeError.empty": "Choisissez au moins un élément.",
  "history.scopeError.outside_period": "Un ou plusieurs dossiers sont hors de la période choisie.",
  "history.scopeError.not_found": "Un ou plusieurs dossiers sont introuvables.",
  "history.scopeError.invalid_period": "Cette période n'est pas valide.",
  "history.scopeError.note_too_long": "La note pour le médecin doit compter 1 000 caractères au plus.",
  "history.scopeError.ambiguous_shape": "Choisissez les dossiers d'une seule façon.",
  "history.shareScopeProfile": "profil",
  "history.shareScopeIdentity": "identité",
  "history.shareScopeDocuments": "documents",
  "history.shareScopeAiShort": "IA",
  "history.shareScopePeriod.whole": "Historique complet",
  "history.shareScopePeriod.12m": "12 derniers mois",
  "history.shareScopePeriod.3y": "3 dernières années",
  "history.shareScopePeriod.5y": "5 dernières années",
  "history.shareScopePeriod.custom": "Période personnalisée",
  "history.shareScopePeriodRange": "{label} ({from} – {to})",
  "history.period.12m": "12 derniers mois",
  "history.period.3y": "3 dernières années",
  "history.period.5y": "5 dernières années",
  "history.period.all": "Historique complet",
  "history.period.custom": "Personnalisée",
  "history.periodChip": "{label} ({count})",
  "history.periodFrom": "Du",
  "history.periodTo": "Au",
  "history.periodUndated": "Inclure les dossiers sans date ({count})",
  "history.periodInvalid": "Indiquez une date de début antérieure ou égale à la date de fin.",
  "history.shareLog": "Journal d'accès",
  "history.shareLogEmpty": "Pas encore d'ouverture",
  "history.shareEvent.unlocked": "Ouvert",
  "history.shareEvent.file_downloaded": "Fichier téléchargé",
  "history.shareEvent.exported": "Exporté",
  "history.shareClient.chrome": "Chrome",
  "history.shareClient.firefox": "Firefox",
  "history.shareClient.safari": "Safari",
  "history.shareClient.edge": "Edge",
  "history.shareClient.other": "Autre navigateur",
  "history.shareBanner": "Partagé par le patient ou la personne qui s'en occupe. Non vérifié par MedConcil. Les avis d'IA sont signalés et ne sont pas des diagnostics.",
  "history.shareCodePrompt": "Saisissez le code d'accès",
  "history.shareCodeLabel": "Code d'accès",
  "history.shareCodeContinue": "Continuer",
  "history.shareCodeOptional": "Si vous n'avez pas reçu de code, continuez.",
  "history.shareInvalidCode": "Ce code n'est pas valable.",
  "history.shareLocked": "Trop de tentatives. Réessayez plus tard.",
  "history.shareNotFound": "Ce lien n'est pas disponible.",
  "history.shareDownloadPdf": "Télécharger le PDF",
  "history.shareDownloadFhir": "Télécharger le FHIR",
  "history.shareDownloadZip": "Télécharger le ZIP",
  "history.shareLoading": "Chargement…",
  "history.shareViewFile": "Document",
  "history.shareCloseFile": "Fermer",
};
